var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { defaultTheme } from '@hn-ui/themes';
import { Tooltip } from '@hn-ui/tooltips';
import { styled } from 'styled-components';
import { ArrowRightClosedNoLineIcon } from '../../images/icons';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-ah0mlj" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  height: 10px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 2px;\n"], ["\n  display: flex;\n  position: relative;\n  height: 10px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: 2px;\n"])), function (_a) {
    var emptyColor = _a.emptyColor;
    return emptyColor;
});
var Filler = styled.div.withConfig({ displayName: "Filler", componentId: "sc-1gxemv" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  height: 100%;\n  background-color: ", ";\n  left: ", ";\n  width: ", ";\n  border-radius: 2px;\n"], ["\n  position: absolute;\n  height: 100%;\n  background-color: ", ";\n  left: ", ";\n  width: ", ";\n  border-radius: 2px;\n"])), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var start = _a.start;
    return start + "%";
}, function (_a) {
    var start = _a.start, end = _a.end;
    return "calc(" + end + "% - " + start + "%)";
});
var ScArrowRightClosed = styled(ArrowRightClosedNoLineIcon).withConfig({ displayName: "ScArrowRightClosed", componentId: "sc-12z0dr5" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  width: unset;\n  height: unset;\n  left: ", ";\n  top: 0;\n  z-index: 1;\n  & path {\n    fill: ", ";\n  }\n"], ["\n  position: absolute;\n  width: unset;\n  height: unset;\n  left: ", ";\n  top: 0;\n  z-index: 1;\n  & path {\n    fill: ", ";\n  }\n"])), function (_a) {
    var startposition = _a.startposition;
    return startposition;
}, function (_a) {
    var color = _a.color;
    return color;
});
var ArrowLine = styled.div.withConfig({ displayName: "ArrowLine", componentId: "sc-1o0qx41" })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  transform: translate(-100%, -50%);\n  left: ", ";\n  width: ", ";\n  height: 2px;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  transform: translate(-100%, -50%);\n  left: ", ";\n  width: ", ";\n  height: 2px;\n  background-color: ", ";\n"])), function (_a) {
    var startposition = _a.startposition;
    return startposition;
}, function (_a) {
    var length = _a.length;
    return length;
}, function (_a) {
    var color = _a.color;
    return color;
});
var Progress = function (_a) {
    var _b, _c, _d;
    var _e = _a.data, data = _e === void 0 ? [] : _e, _f = _a.emptyColor, emptyColor = _f === void 0 ? defaultTheme.colors.black95 : _f, pushed = _a.pushed, pushedColor = _a.pushedColor, _g = _a.arrowLength, arrowLength = _g === void 0 ? 0 : _g, pushInfo = _a.pushInfo, _h = _a.currentGrade, currentGrade = _h === void 0 ? -1 : _h, rest = __rest(_a, ["data", "emptyColor", "pushed", "pushedColor", "arrowLength", "pushInfo", "currentGrade"]);
    var startPosition = 0;
    var gradeDiff = currentGrade - ((_b = pushInfo === null || pushInfo === void 0 ? void 0 : pushInfo.startGrade) !== null && _b !== void 0 ? _b : 0);
    var _start = (_d = (_c = data.find(function (d) { return d.push; })) === null || _c === void 0 ? void 0 : _c.start) !== null && _d !== void 0 ? _d : 0;
    if (pushInfo) {
        startPosition = (gradeDiff - 1) * 100 + (100 - pushInfo.startGap) + _start;
    }
    return (_jsxs(Container, __assign({}, rest, { emptyColor: emptyColor }, { children: [data.map(function (_a, index) {
                var start = _a.start, end = _a.end, color = _a.color;
                return (_jsx(Filler, { start: start, end: end, color: color, role: 'progress' }, index));
            }), pushed && (_jsxs(_Fragment, { children: [_jsx(Tooltip, __assign({ content: 'Mid-year test replacement', maxWidth: 'none' }, { children: _jsx(ArrowLine, { color: pushedColor, startposition: "calc(" + _start + "%)", length: "calc(" + startPosition + "% + " + gradeDiff * 12 + "px)" }, void 0) }), void 0), _jsx(ScArrowRightClosed, { color: pushedColor, startposition: "calc(" + _start + "% - 10px)" }, void 0)] }, void 0))] }), void 0));
};
export { Progress };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
